import React from 'react';
import ReactDOM from 'react-dom';
import { Field,reduxForm,formValueSelector } from 'redux-form';
import Select from 'react-select';
import { connect } from 'react-redux'
import LoadingSmall from '../../../components/LoadingSmall.js';


const validate = values => {
    const errors = {}

    if(!values.name) {
        errors.name = 'Required';
    }

    if(values.auto_update === true) {
        if(!values.amount && !values.clone) {
            errors.amount = 'Required';
        }else{
            if(values.clone && !values.code) {
                errors.code = 'Required';
            }
        }
    }else{
        if(!values.code) {
            errors.code = 'Required';
        }
    }

    return errors
}

const renderField = ({ input, name,className,placeholder, title, disabled,type, meta: { touched, error } }) => (

    <div className={`form-group form-material floating ${touched && error ? 'has-danger':''}`} data-plugin="formMaterial">
        <input {...input}  placeholder={placeholder} name={name} className={className} type={type} disabled={disabled} />
        <label className="floating-label">{title}</label>
        <small className="text-help">{touched && ((error && <span>{error}</span>))}</small>
    </div>
)

const checkbox = ({ input, name,className,placeholder, title, type, meta: { touched, error } }) => (
    <div className="checkbox-custom checkbox-primary">
        <input {...input} name={name} type={type} />
        <label>{title}</label>
    </div>
)

const select = ({ input, options,name,className,disabled,placeholder, title, type, meta: { touched, error } }) => (
    <div className={`form-group form-material floating ${touched && error ? 'has-danger':''}`} data-plugin="formMaterial">
        <select name={name} disabled={disabled} className="form-control" value={input.value} onChange={input.onChange}>
            {options.map((item,i) => {
                return <option key={i} value={item.value}>{item.label}</option>
            })}
        </select>
        <label className="floating-label">{title}</label>
        <small className="text-help">{touched && ((error && <span>{error}</span>))}</small>
    </div>
)

                                    

class CreateDiscount extends React.Component {

    type() {   
        return [
            {
                value:'percent',
                label:'Percent'
            },
            {
                value:'sum',
                label:'Amount off'
            }
            
        ];
    }

    expire() {   
        return [
            {
                value:1,
                label:'24 hours'
            },
            {
                value:2,
                label:'2 days'
            },
            {
                value:3,
                label:'3 days'
            },
            {
                value:4,
                label:'4 days'
            },
            {
                value:5,
                label:'5 days'
            },
            {
                value:6,
                label:'6 days'
            },
            {
                value:7,
                label:'7 days'
            }
            
        ];
    }

    isCodeDisabled() {
        if(this.props.auto_update === true && this.props.clone === true) {
            return false;
        }

        if(this.props.auto_update === true && ! this.props.clone) {
            return true;
        }

        return false;
    }

    isCloning() {
        if(this.props.auto_update === true && this.props.clone === true) {
            return true;
        }

        return false;
    }


    render() {
        const { handleSubmit } = this.props;
        return (
            <form onSubmit={handleSubmit}>
                    <div className="col-sm-12">
    
                                
                            <div className="row">
                                <div className="col-sm-6">
                                    <Field component={renderField} type="text" name="name" placeholder="My first discount" title="Name" className="form-control" />
                                </div>

                                <div className="col-sm-6">
                                    <Field component={renderField} type="text" name="code" disabled={this.isCodeDisabled()} placeholder="20PERCENTOFF" title="Code" className="form-control" />
                                </div>
                                
                            </div>

                            <div className="row">
                                <div className="col-sm-12">
                                    <Field component={checkbox} type="checkbox" name="auto_update" title="Automatically create codes as needed in your store" className="form-control" />
                                </div>

                                {this.props.auto_update ?
                                <div>
                                    <div className="col-sm-4">
                                        <Field component={renderField} disabled={this.isCloning()} type="text" name="amount" placeholder="20" title="Amount" className="form-control" />
                                    </div>

                                    <div className="col-sm-4">
                                        <Field component={select} disabled={this.isCloning()} options={this.type()} name="type" title="Type" />
                                    </div>

                                    <div className="col-sm-4">
                                        <Field component={select} options={this.expire()} name="expire" title="Expire after" />
                                    </div>

                                    <div className="col-sm-12">
                                        <Field component={checkbox} type="checkbox" name="clone" title="Clone existing code" className="form-control" />
                                    </div>
                                </div>:null}
                            </div>

                            <div className="row">
                                <div className="col-sm-12">
                                    {
                                        this.props.isWaiting
                                        ?
                                        <LoadingSmall />
                                        :
                                        <button type="submit" className="btn btn-dark btn-block">Save</button>
                                    }
                                </div>
                            </div>

                            </div>
            </form>
        );
    }
}

const mapStateToProps = (state, ownProps) => ({

});

const selector = formValueSelector('CreateDiscount');

// Decorate the form component
CreateDiscount = reduxForm({
  form: 'CreateDiscount',
  validate,
})(CreateDiscount);

CreateDiscount = connect(
  state => ({
    auto_update:selector(state, 'auto_update'),
  clone:selector(state, 'clone'),
  })
)(CreateDiscount)

export default CreateDiscount;


// WEBPACK FOOTER //
// ./containers/discounts/form/Discount.js